import React from 'react';

function Dashboard(props) {
    return (
        <div>
            hi
        </div>
    );
}

export default Dashboard;